import { useParams } from "react-router-dom";
import {
  useGetGoodsReceivedDetails,
  useGetGoodsReceivedItems,
} from "../../../../../../hooks/api/queries";

export const useEditGoodsReceived = ({ isEnabled = false }) => {
  const { id } = useParams();
  const { data: GRDetails, isLoading } = useGetGoodsReceivedDetails({ id });

  const { data: GRItems, isLoading: isLoadingGRItems } =
    useGetGoodsReceivedItems({ id, isEditMode: true, isEnabled });

  return {
    isLoading: isLoadingGRItems || isLoading,
    GRItems: GRItems || [],
    GRDetails,
  };
};
